import { useCallback, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';

export const useEventHandlers = () => {
  const calendarRef = useRef<FullCalendar>(null);

  // Modal state for event details
  const [modalState, setModalState] = useState({
    isOpen: false,
    eventId: null as string | null,
  });

  // Helper functions for modal state management
  const openModal = useCallback((eventId: string) => {
    setModalState({ isOpen: true, eventId });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({ isOpen: false, eventId: null });
  }, []);

  const handleRowClick = useCallback((cdmId: string | number) => {
    if (cdmId) {
      window.open(
        `https://platform.spacemap42.com/?service=conjunction&board=true&cdm_id=${cdmId}`,
        '_blank'
      );
    }
  }, []);

  const handleCalendarViewChange = useCallback(
    (view: string, setCalendarView: (view: string) => void) => {
      const calendarApi = calendarRef.current?.getApi();
      if (calendarApi) {
        calendarApi.changeView(view);
        setCalendarView(view);
      }
    },
    []
  );

  const handleEventsCardClick = useCallback(() => {
    // Scroll to space events section
    const spaceEventsSection = document.querySelector(
      '[data-section="space-events"]'
    );
    if (spaceEventsSection) {
      spaceEventsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, []);

  const handleCalendarEventClick = useCallback((info: any) => {
    info.jsEvent.preventDefault();
    if (info.event.extendedProps.htmlLink) {
      window.open(info.event.extendedProps.htmlLink, '_blank');
    } else {
      window.open(
        `https://www.spacemap42.com/spacecalendar/events/detail?id=${info.event.id}`,
        '_self'
      );
    }
  }, []);

  return {
    // Refs
    calendarRef,

    // Modal state
    modalState,
    openModal,
    closeModal,

    // Event handlers
    handleRowClick,
    handleCalendarViewChange,
    handleEventsCardClick,
    handleCalendarEventClick,
  };
};
